import { Link, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import "./Topbar.css";
import logo from "../../assets/image/logo.png";
import adminImg from "../../assets/image/01.jpg";

export default function Topbar({ onMenu }) {
  const navigate = useNavigate();
  const menuRef = useRef();

  const logout = () => {
    localStorage.removeItem("loggedInAdmin");
    navigate("/admin/login");
  };

  const toggleUserMenu = () => {
    menuRef.current.classList.toggle("show");
  };

  useEffect(() => {
    const close = (e) => {
      if (!e.target.closest(".admin-profile")) {
        menuRef.current.classList.remove("show");
      }
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  return (
    <header className="top-header">
      <div className="header-left">
        <button className="icon-btn" onClick={onMenu}>
          ☰
        </button>

        <Link to="/admin/dashboard">
          <img src={logo} className="top-logo" alt="NX Optics" />
        </Link>
      </div>

      <div className="header-right">
        <div className="admin-profile" onClick={toggleUserMenu}>
          <img src={adminImg} alt="Admin" />
          <span className="caret">▾</span>

          <div ref={menuRef} className="user-menu">
            <Link to="/admin/account">My Profile</Link>
            <button onClick={logout}>Logout</button>
          </div>
        </div>
      </div>
    </header>
  );
}
